/**
 * Value Object for validation results (Single Responsibility)
 */
export class ValidationResult {
  constructor(isValid, message = '', details = {}) {
    this.isValid = isValid;
    this.message = message;
    this.details = details;
  }

  static valid(message = 'Valid', details = {}) {
    return new ValidationResult(true, message, details);
  }

  static invalid(message, details = {}) {
    return new ValidationResult(false, message, details);
  }

  toString() {
    return this.isValid ? 'Valid' : `Invalid: ${this.message}`;
  }
}